export const QUOTE_PAYMENT_TYPES = {
  CARD: 'Tarjeta',
  RECEIPT: 'Recibo',
  TRANSFER: 'Transferencia',
} as const;
